import { render, staticRenderFns } from "./OrderCell.vue?vue&type=template&id=4635511b&scoped=true&"
import script from "./OrderCell.vue?vue&type=script&lang=ts&"
export * from "./OrderCell.vue?vue&type=script&lang=ts&"
import style0 from "./OrderCell.vue?vue&type=style&index=0&id=4635511b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4635511b",
  null
  
)

export default component.exports